import {z} from 'zod';
import dedent from 'dedent';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'set-component-code' as const;

const argumentZod = z.object({
  componentId: z
    .string()
    .describe('The ID of the code component to set the code for.'),
  code: z
    .string()
    .describe('The full source code to set for the code component.'),
});

export const setComponentCodeTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Set component code',
  prettyErrors: {
    fallback: 'Unable to set component code.',
    patterns: [
      {
        match: 'not found',
        message: 'Component not found.',
      },
      {
        match: 'compilation',
        message: 'Code failed to compile.',
      },
    ],
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Sets the full source code for a code component. Use this tool to write or completely replace the code of a code component identified by its component ID.

      The code will be compiled after being set. If compilation fails, the error will be returned but the code will still be saved.

      For targeted edits to an existing code component, prefer 'edit-component-code' which is faster and more token-efficient.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SiteSymbol', action: 'modify'}],
  confirmBeforeExecuting: false,
  timeout: 30000,
});
